var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"price-card"},[_c('div',{staticClass:"flex-grow p-4"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("content")],2),_c('div',{staticClass:"price"},[_vm._t("amount"),_vm._v(" Kč")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }